import { ADD_COLUMN_CELL } from "@/features/data-curation/gridCells";
import { Plus } from "lucide-react";

/** Last header cell of the grid: adds a column, and stays in view on a side scroll. */
export const AddColumnHeaderCell = ({ onAdd }: { onAdd: () => void }) => (
  <th scope="col" className={`${ADD_COLUMN_CELL} z-40 bg-zinc-50 p-0 align-middle`}>
    <button
      type="button"
      onClick={onAdd}
      aria-label="Add a column"
      title="Add a column"
      className="flex w-full items-center justify-center py-3 text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-zinc-900"
    >
      <Plus className="h-4 w-4" aria-hidden />
    </button>
  </th>
);

/** The cell under the Add column button in each row, so the right edge stays one strip. */
export const AddColumnBodyCell = () => <td className={`${ADD_COLUMN_CELL} z-10 bg-white`} />;
